(function(){
  // ─────────────────────────────────────────────────────────
  // PRICING — same as the configurator and pricing simulator
  // ─────────────────────────────────────────────────────────
  var CLARITY_RATES = { vvs1d:1575, vvs2d:1260, vvs1e:1100, vvs2e:750 };

  // ─────────────────────────────────────────────────────────
  // SIZING — industry-standard 1ct dimensions per shape (mm)
  // Sources: GIA / AGS / IGI published charts (normalized for ideal cut)
  // Scaled to other carats by cube-root of weight (since carat is mass and
  // dimensions scale as volume^(1/3) for a fixed cut depth).
  // ─────────────────────────────────────────────────────────
  var SHAPES_1CT = {
    round:    { l: 6.50, w: 6.50, name: 'Round' },
    oval:     { l: 7.70, w: 5.50, name: 'Oval' },
    cushion:  { l: 6.93, w: 5.34, name: 'Cushion' },
    radiant:  { l: 6.00, w: 5.00, name: 'Radiant' },
    pear:     { l: 8.00, w: 5.30, name: 'Pear' },
    emerald:  { l: 6.50, w: 4.60, name: 'Emerald' },
    marquise: { l: 10.00, w: 5.00, name: 'Marquise' }
  };

  function dimsFor(shape, carat) {
    var b = SHAPES_1CT[shape] || SHAPES_1CT.round;
    var s = Math.cbrt(carat);
    return { l: +(b.l * s).toFixed(2), w: +(b.w * s).toFixed(2) };
  }

  function priceFor(carat, grade) {
    var rate = CLARITY_RATES[grade] || 0;
    return Math.round(carat * rate);
  }

  function fmtMoney(n) {
    return '$' + n.toLocaleString('en-US');
  }

  // ─────────────────────────────────────────────────────────
  // SHAPE SILHOUETTES — IGI cert-style outlines
  // Each shape has ONE silhouette path used at any render size.
  // Big illustration adds a subtle table outline + axes for diamond feel.
  // Actual-size mark is the same silhouette at calibrated mm.
  //
  // viewBox dimensions match the shape's NATURAL jewelry orientation:
  //   • Oval: horizontal (length = X axis)
  //   • Emerald/Radiant/Pear/Marquise: vertical (length = Y axis, point up for pear)
  //   • Round/Cushion/Princess/Asscher/Heart: square (1:1)
  // ─────────────────────────────────────────────────────────
  // Real diamond photography for the big illustration — uploaded to Montare's
  // Shopify Files. These show actual faceting / fire / scintillation rather
  // than line drawings. Orientation field stays so the actual-size mark below
  // renders at the correct L:W aspect.
  var STONE_PHOTOS = {
    round:    'https://cdn.shopify.com/s/files/1/0729/0208/2726/files/montare-shape-round-v3.png?width=510',
    oval:     'https://cdn.shopify.com/s/files/1/0729/0208/2726/files/montare-shape-oval-v3.png?width=510',
    cushion:  'https://cdn.shopify.com/s/files/1/0729/0208/2726/files/montare-shape-cushion-v3.png?width=510',
    radiant:  'https://cdn.shopify.com/s/files/1/0729/0208/2726/files/montare-shape-radiant-v3.png?width=510',
    pear:     'https://cdn.shopify.com/s/files/1/0729/0208/2726/files/montare-shape-pear-v3.png?width=510',
    emerald:  'https://cdn.shopify.com/s/files/1/0729/0208/2726/files/montare-shape-emerald-v3.png?width=510',
    marquise: 'https://cdn.shopify.com/s/files/1/0729/0208/2726/files/montare-shape-marquise-v3.png?width=510'
  };

  var SHAPES = {
    round: {
      vbW: 30, vbH: 30, orient: 'square',
      silhouette: '<circle class="gem-girdle" cx="15" cy="15" r="10"/>',
      table:      '<circle class="gem-table"  cx="15" cy="15" r="6"/>',
      facets:
        '<line class="gem-facet" x1="15" y1="5"  x2="15" y2="9"/>' +
        '<line class="gem-facet" x1="15" y1="21" x2="15" y2="25"/>' +
        '<line class="gem-facet" x1="5"  y1="15" x2="9"  y2="15"/>' +
        '<line class="gem-facet" x1="21" y1="15" x2="25" y2="15"/>'
    },
    // Configurator draws oval as a tall ellipse (rx=9 ry=11). For the comparison
    // tool we render it horizontally (lying on its side, as it's actually worn).
    oval: {
      vbW: 30, vbH: 30, orient: 'horizontal',
      silhouette: '<ellipse class="gem-girdle" cx="15" cy="15" rx="11" ry="9"/>',
      table:      '<ellipse class="gem-table"  cx="15" cy="15" rx="7"  ry="5.5"/>',
      facets: ''
    },
    cushion: {
      vbW: 30, vbH: 30, orient: 'square',
      silhouette: '<rect class="gem-girdle" x="6"   y="6"   width="18" height="18" rx="5"/>',
      table:      '<rect class="gem-table"  x="9.5" y="9.5" width="11" height="11" rx="2.5"/>',
      facets: ''
    },
    emerald: {
      vbW: 30, vbH: 30, orient: 'vertical',
      silhouette: '<polygon class="gem-girdle" points="9.5,5 20.5,5 25,9.5 25,20.5 20.5,25 9.5,25 5,20.5 5,9.5"/>',
      table:      '<polygon class="gem-table"  points="11.5,9 18.5,9 21,11.5 21,18.5 18.5,21 11.5,21 9,18.5 9,11.5"/>',
      facets: ''
    },
    radiant: {
      vbW: 30, vbH: 30, orient: 'vertical',
      silhouette: '<polygon class="gem-girdle" points="9,5 21,5 25,9 25,21 21,25 9,25 5,21 5,9"/>',
      table: '',
      facets:
        '<line class="gem-facet" x1="9"  y1="5" x2="11" y2="8.5"/>' +
        '<line class="gem-facet" x1="21" y1="5" x2="19" y2="8.5"/>'
    },
    pear: {
      vbW: 30, vbH: 30, orient: 'vertical',
      silhouette: '<path class="gem-girdle" d="M15 26C9.5 26 7 21.5 7 17C7 10.5 10.5 4 15 4C19.5 4 23 10.5 23 17C23 21.5 20.5 26 15 26Z"/>',
      table: '',
      facets: ''
    },
    // Configurator draws marquise horizontally (the d="M3 15..." path); we keep that.
    marquise: {
      vbW: 30, vbH: 30, orient: 'horizontal',
      silhouette: '<path class="gem-girdle" d="M3 15C3 15 8.5 7 15 7C21.5 7 27 15 27 15C27 15 21.5 23 15 23C8.5 23 3 15 3 15Z"/>',
      table: '',
      facets: ''
    }
  };

  function getShapeDef(shape) {
    return SHAPES[shape] || SHAPES.round;
  }

  // Big illustration: real diamond photography (showing actual facets / fire).
  // Auto-sized 170px desktop / 130px mobile — both sides use the same image
  // since this is for shape RECOGNITION; the actual physical size difference
  // is shown via the "Actual size" outline below.
  function buildStoneSvg(shape) {
    var src = STONE_PHOTOS[shape] || STONE_PHOTOS.round;
    var maxDim = window.innerWidth < 600 ? 130 : 170;
    return '<img class="mdc-stone-photo" src="' + src +
           '" alt="' + shape + ' diamond" loading="lazy" ' +
           'style="max-width:' + maxDim + 'px;max-height:' + maxDim + 'px;width:auto;height:auto;display:block;"/>';
  }

  // Render the small ACTUAL-SIZE mark at calibrated mm.
  // Each shape has its own outline path drawn in a 100×100 box, then stretched
  // (preserveAspectRatio="none") to true L × W in pixels. Outlines:
  //   round    — circle (always 1:1)
  //   oval     — ellipse stretched to L × W
  //   cushion  — rounded square (1:1)
  //   radiant  — octagon (corner cuts ~14%)
  //   emerald  — octagon (same outline as radiant, but rendered at the emerald's L:W)
  //   pear     — teardrop, point up
  //   marquise — lens, horizontal
  function scaleOutlinePath(shape) {
    switch (shape) {
      case 'round':
        return '<circle class="scale-shape" cx="50" cy="50" r="48"/>';
      case 'oval':
        return '<ellipse class="scale-shape" cx="50" cy="50" rx="48" ry="48"/>';
      case 'cushion':
        return '<rect class="scale-shape" x="2" y="2" width="96" height="96" rx="22" ry="22"/>';
      case 'radiant':
      case 'emerald':
        return '<polygon class="scale-shape" points="14,2 86,2 98,14 98,86 86,98 14,98 2,86 2,14"/>';
      case 'pear':
        return '<path class="scale-shape" d="M50 2 C 80 14 98 40 98 60 C 98 86 76 98 50 98 C 24 98 2 86 2 60 C 2 40 20 14 50 2 Z"/>';
      case 'marquise':
        return '<path class="scale-shape" d="M2 50 C 15 8 35 2 50 2 C 65 2 85 8 98 50 C 85 92 65 98 50 98 C 35 98 15 92 2 50 Z"/>';
    }
    return '<circle class="scale-shape" cx="50" cy="50" r="48"/>';
  }
  function buildScaleMark(shape, lengthMm, widthMm, pxPerMm) {
    var def = getShapeDef(shape);
    var pxL = Math.max(8, lengthMm * pxPerMm);
    var pxW = Math.max(8, widthMm * pxPerMm);
    var svgPxW, svgPxH;
    if (def.orient === 'horizontal') { svgPxW = pxL; svgPxH = pxW; }
    else if (def.orient === 'vertical') { svgPxW = pxW; svgPxH = pxL; }
    else { svgPxW = pxW; svgPxH = pxL; } // square
    return '<svg class="mdc-stone-scale-svg" width="' + svgPxW.toFixed(1) +
           '" height="' + svgPxH.toFixed(1) +
           '" viewBox="0 0 100 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">' +
           scaleOutlinePath(shape) + '</svg>';
  }

  // Legacy stub — no longer used but kept so old callers don't error
  function _legacyShapeSvgPaths_REMOVED(shape) {
    var def = getShapeDef(shape);
    return { vbW: def.vbW, vbH: def.vbH, paths: def.silhouette + (def.table || '') };
    switch (shape) {
      case 'round':
        // Classic round brilliant from above: girdle + table octagon + 8 bezel + 16 star/upper-girdle
        return { vbW: 200, vbH: 200, paths:
          // Girdle (outer)
          '<circle class="gem-outer" cx="100" cy="100" r="96"/>' +
          // Table (central octagon)
          '<polygon class="gem-table" points="78,68 122,68 142,100 122,132 78,132 58,100"/>' +
          // 8 bezel facets (lines from table corners to girdle)
          '<line class="gem-facet" x1="78"  y1="68"  x2="44"  y2="34"/>' +
          '<line class="gem-facet" x1="122" y1="68"  x2="156" y2="34"/>' +
          '<line class="gem-facet" x1="142" y1="100" x2="196" y2="100"/>' +
          '<line class="gem-facet" x1="122" y1="132" x2="156" y2="166"/>' +
          '<line class="gem-facet" x1="78"  y1="132" x2="44"  y2="166"/>' +
          '<line class="gem-facet" x1="58"  y1="100" x2="4"   y2="100"/>' +
          // 4 main axis facets meeting table edges
          '<line class="gem-facet" x1="100" y1="68"  x2="100" y2="4"/>' +
          '<line class="gem-facet" x1="100" y1="132" x2="100" y2="196"/>' +
          // 16 upper-girdle facet lines (subtle)
          '<line class="gem-facet-thin" x1="100" y1="4"   x2="72"  y2="14"/>' +
          '<line class="gem-facet-thin" x1="100" y1="4"   x2="128" y2="14"/>' +
          '<line class="gem-facet-thin" x1="44"  y1="34"  x2="28"  y2="56"/>' +
          '<line class="gem-facet-thin" x1="44"  y1="34"  x2="72"  y2="14"/>' +
          '<line class="gem-facet-thin" x1="156" y1="34"  x2="172" y2="56"/>' +
          '<line class="gem-facet-thin" x1="156" y1="34"  x2="128" y2="14"/>' +
          '<line class="gem-facet-thin" x1="196" y1="100" x2="172" y2="56"/>' +
          '<line class="gem-facet-thin" x1="196" y1="100" x2="172" y2="144"/>' +
          '<line class="gem-facet-thin" x1="156" y1="166" x2="172" y2="144"/>' +
          '<line class="gem-facet-thin" x1="156" y1="166" x2="128" y2="186"/>' +
          '<line class="gem-facet-thin" x1="100" y1="196" x2="128" y2="186"/>' +
          '<line class="gem-facet-thin" x1="100" y1="196" x2="72"  y2="186"/>' +
          '<line class="gem-facet-thin" x1="44"  y1="166" x2="72"  y2="186"/>' +
          '<line class="gem-facet-thin" x1="44"  y1="166" x2="28"  y2="144"/>' +
          '<line class="gem-facet-thin" x1="4"   y1="100" x2="28"  y2="144"/>' +
          '<line class="gem-facet-thin" x1="4"   y1="100" x2="28"  y2="56"/>'
        };
      case 'oval':
        // Oval brilliant from above
        return { vbW: 280, vbH: 200, paths:
          '<ellipse class="gem-outer" cx="140" cy="100" rx="136" ry="96"/>' +
          '<ellipse class="gem-table" cx="140" cy="100" rx="64" ry="40"/>' +
          // 8 radial facet lines
          '<line class="gem-facet" x1="140" y1="60"  x2="140" y2="4"/>' +
          '<line class="gem-facet" x1="140" y1="140" x2="140" y2="196"/>' +
          '<line class="gem-facet" x1="204" y1="100" x2="276" y2="100"/>' +
          '<line class="gem-facet" x1="76"  y1="100" x2="4"   y2="100"/>' +
          '<line class="gem-facet" x1="195" y1="72"  x2="240" y2="38"/>' +
          '<line class="gem-facet" x1="195" y1="128" x2="240" y2="162"/>' +
          '<line class="gem-facet" x1="85"  y1="72"  x2="40"  y2="38"/>' +
          '<line class="gem-facet" x1="85"  y1="128" x2="40"  y2="162"/>'
        };
      case 'cushion':
        // Rounded square with cushion facet pattern
        return { vbW: 200, vbH: 200, paths:
          '<rect class="gem-outer" x="4" y="4" width="192" height="192" rx="38" ry="38"/>' +
          '<rect class="gem-table" x="56" y="56" width="88" height="88" rx="14" ry="14"/>' +
          '<line class="gem-facet" x1="56"  y1="56"  x2="20"  y2="20"/>' +
          '<line class="gem-facet" x1="144" y1="56"  x2="180" y2="20"/>' +
          '<line class="gem-facet" x1="144" y1="144" x2="180" y2="180"/>' +
          '<line class="gem-facet" x1="56"  y1="144" x2="20"  y2="180"/>' +
          '<line class="gem-facet-thin" x1="100" y1="56"  x2="100" y2="4"/>' +
          '<line class="gem-facet-thin" x1="100" y1="144" x2="100" y2="196"/>' +
          '<line class="gem-facet-thin" x1="144" y1="100" x2="196" y2="100"/>' +
          '<line class="gem-facet-thin" x1="56"  y1="100" x2="4"   y2="100"/>'
        };
      case 'princess':
        return { vbW: 200, vbH: 200, paths:
          '<rect class="gem-outer" x="4" y="4" width="192" height="192"/>' +
          // Diagonal X from corners
          '<line class="gem-facet" x1="4" y1="4" x2="196" y2="196"/>' +
          '<line class="gem-facet" x1="196" y1="4" x2="4" y2="196"/>' +
          // Inner diamond (rotated square table)
          '<polygon class="gem-table" points="100,52 148,100 100,148 52,100"/>' +
          // Quarter divisions
          '<line class="gem-facet-thin" x1="100" y1="4"   x2="100" y2="52"/>' +
          '<line class="gem-facet-thin" x1="100" y1="148" x2="100" y2="196"/>' +
          '<line class="gem-facet-thin" x1="4"   y1="100" x2="52"  y2="100"/>' +
          '<line class="gem-facet-thin" x1="148" y1="100" x2="196" y2="100"/>'
        };
      case 'emerald':
        // Step cut: octagonal outer + 3 concentric octagons (table + step ledges)
        return { vbW: 200, vbH: 280, paths:
          '<polygon class="gem-outer" points="40,4 160,4 196,40 196,240 160,276 40,276 4,240 4,40"/>' +
          '<polygon class="gem-facet" points="56,28 144,28 172,56 172,224 144,252 56,252 28,224 28,56"/>' +
          '<polygon class="gem-facet" points="72,48 128,48 152,72 152,208 128,232 72,232 48,208 48,72"/>' +
          '<polygon class="gem-table" points="84,72 116,72 136,92 136,188 116,208 84,208 64,188 64,92"/>'
        };
      case 'radiant':
        // Octagonal outer with radiant brilliant facet pattern
        return { vbW: 200, vbH: 240, paths:
          '<polygon class="gem-outer" points="40,4 160,4 196,40 196,200 160,236 40,236 4,200 4,40"/>' +
          '<polygon class="gem-table" points="76,80 124,80 144,100 144,140 124,160 76,160 56,140 56,100"/>' +
          // Bezel facet lines from table corners to outer corners
          '<line class="gem-facet" x1="76"  y1="80"  x2="40"  y2="4"/>' +
          '<line class="gem-facet" x1="124" y1="80"  x2="160" y2="4"/>' +
          '<line class="gem-facet" x1="144" y1="100" x2="196" y2="40"/>' +
          '<line class="gem-facet" x1="144" y1="140" x2="196" y2="200"/>' +
          '<line class="gem-facet" x1="124" y1="160" x2="160" y2="236"/>' +
          '<line class="gem-facet" x1="76"  y1="160" x2="40"  y2="236"/>' +
          '<line class="gem-facet" x1="56"  y1="140" x2="4"   y2="200"/>' +
          '<line class="gem-facet" x1="56"  y1="100" x2="4"   y2="40"/>'
        };
      case 'pear':
        // Pear (teardrop) brilliant
        return { vbW: 200, vbH: 280, paths:
          '<path class="gem-outer" d="M100,4 C 160,30 196,100 196,170 C 196,236 150,272 100,272 C 50,272 4,236 4,170 C 4,100 40,30 100,4 Z"/>' +
          '<ellipse class="gem-table" cx="100" cy="160" rx="44" ry="60"/>' +
          // Radial facets
          '<line class="gem-facet" x1="100" y1="4"   x2="100" y2="100"/>' +
          '<line class="gem-facet" x1="56"  y1="160" x2="4"   y2="170"/>' +
          '<line class="gem-facet" x1="144" y1="160" x2="196" y2="170"/>' +
          '<line class="gem-facet" x1="100" y1="220" x2="100" y2="272"/>' +
          '<line class="gem-facet" x1="70"  y1="115" x2="42"  y2="80"/>' +
          '<line class="gem-facet" x1="130" y1="115" x2="158" y2="80"/>' +
          '<line class="gem-facet-thin" x1="72"  y1="210" x2="40"  y2="240"/>' +
          '<line class="gem-facet-thin" x1="128" y1="210" x2="160" y2="240"/>'
        };
      case 'marquise':
        // Marquise (navette) — pointed at both ends
        return { vbW: 200, vbH: 400, paths:
          '<path class="gem-outer" d="M100,4 C 150,70 196,160 196,200 C 196,240 150,330 100,396 C 50,330 4,240 4,200 C 4,160 50,70 100,4 Z"/>' +
          '<ellipse class="gem-table" cx="100" cy="200" rx="44" ry="120"/>' +
          '<line class="gem-facet" x1="100" y1="4"   x2="100" y2="80"/>' +
          '<line class="gem-facet" x1="100" y1="320" x2="100" y2="396"/>' +
          '<line class="gem-facet" x1="56"  y1="200" x2="4"   y2="200"/>' +
          '<line class="gem-facet" x1="144" y1="200" x2="196" y2="200"/>' +
          '<line class="gem-facet-thin" x1="72"  y1="100" x2="40"  y2="120"/>' +
          '<line class="gem-facet-thin" x1="128" y1="100" x2="160" y2="120"/>' +
          '<line class="gem-facet-thin" x1="72"  y1="300" x2="40"  y2="280"/>' +
          '<line class="gem-facet-thin" x1="128" y1="300" x2="160" y2="280"/>'
        };
      case 'asscher':
        // Square step cut (similar to emerald but square)
        return { vbW: 200, vbH: 200, paths:
          '<polygon class="gem-outer" points="40,4 160,4 196,40 196,160 160,196 40,196 4,160 4,40"/>' +
          '<polygon class="gem-facet" points="56,28 144,28 172,56 172,144 144,172 56,172 28,144 28,56"/>' +
          '<polygon class="gem-facet" points="72,48 128,48 152,72 152,128 128,152 72,152 48,128 48,72"/>' +
          '<polygon class="gem-table" points="84,72 116,72 136,92 136,108 116,128 84,128 64,108 64,92"/>' +
          // Diagonal lines to corners for the Asscher's signature X pattern
          '<line class="gem-facet" x1="4"   y1="40"  x2="64"  y2="92"/>' +
          '<line class="gem-facet" x1="196" y1="40"  x2="136" y2="92"/>' +
          '<line class="gem-facet" x1="4"   y1="160" x2="64"  y2="108"/>' +
          '<line class="gem-facet" x1="196" y1="160" x2="136" y2="108"/>'
        };
      case 'heart':
        return { vbW: 200, vbH: 200, paths:
          '<path class="gem-outer" d="M100,196 C 4,130 4,40 56,16 C 80,4 100,28 100,52 C 100,28 120,4 144,16 C 196,40 196,130 100,196 Z"/>' +
          '<path class="gem-table" d="M100,148 C 50,110 50,68 76,52 C 88,46 100,58 100,74 C 100,58 112,46 124,52 C 150,68 150,110 100,148 Z"/>' +
          '<line class="gem-facet" x1="100" y1="52"  x2="100" y2="180"/>' +
          '<line class="gem-facet-thin" x1="40"  y1="80"  x2="76"  y2="100"/>' +
          '<line class="gem-facet-thin" x1="160" y1="80"  x2="124" y2="100"/>'
        };
      default:
        return shapeSvgPaths('round');
    }
  }

  // (legacy buildStoneSvg + buildScaleMark removed — new versions above)

  // ─────────────────────────────────────────────────────────
  // CALIBRATION — multiple reference objects
  //   Credit card (ISO/IEC 7810 ID-1): 85.60 × 53.98 mm
  //   Loonie ($1 CAD):  26.50 mm diameter
  //   Quarter (25¢ CA): 23.88 mm diameter
  //   Penny  (1¢ CA):   19.05 mm diameter
  // Smaller references work better on mobile screens.
  // ─────────────────────────────────────────────────────────
  var CAL_KEY = 'montare_cal_pxpermm_v1';
  var CAL_REF_KEY = 'montare_cal_ref_v1';

  function getCalibration() {
    var v = parseFloat(localStorage.getItem(CAL_KEY) || '0');
    if (v > 0) return v;
    // Default fallback: assume 96 DPI = 3.78 px/mm (standard CSS reference)
    return 3.78;
  }
  function setCalibration(pxPerMm) {
    try { localStorage.setItem(CAL_KEY, String(pxPerMm)); } catch(e){}
  }
  function isCalibrated() {
    return parseFloat(localStorage.getItem(CAL_KEY) || '0') > 0;
  }

  // ─────────────────────────────────────────────────────────
  // DOM REFS
  // ─────────────────────────────────────────────────────────
  var modal      = document.getElementById('mdc-modal');
  var canvasA    = document.getElementById('mdc-canvas-a');
  var canvasB    = document.getElementById('mdc-canvas-b');
  var mmA        = document.getElementById('mdc-mm-a');
  var mmB        = document.getElementById('mdc-mm-b');
  var priceA     = document.getElementById('mdc-price-a');
  var priceB     = document.getElementById('mdc-price-b');
  var caratA     = document.getElementById('mdc-carat-a');
  var caratB     = document.getElementById('mdc-carat-b');
  var shapeSel   = document.getElementById('mdc-shape');
  var gradeSel   = document.getElementById('mdc-grade');
  var deltaEl    = document.getElementById('mdc-delta');
  var verdictEl  = document.getElementById('mdc-verdict-desc');
  var calBanner  = document.getElementById('mdc-cal-banner');
  var calMsg     = document.getElementById('mdc-cal-msg');
  var calUi      = document.getElementById('mdc-cal-ui');
  var calStart   = document.getElementById('mdc-cal-start');
  var calSave    = document.getElementById('mdc-cal-save');
  var calCancel  = document.getElementById('mdc-cal-cancel');
  var calCard    = document.getElementById('mdc-cal-card');
  var calSlider  = document.getElementById('mdc-cal-slider');
  var calRefSel  = document.getElementById('mdc-cal-ref');

  // ─────────────────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────────────────
  function visibleDifferenceCopy(dimsA, dimsB, shape) {
    // Compute the diameter difference (avg of l, w) in mm
    var dA = (dimsA.l + dimsA.w) / 2;
    var dB = (dimsB.l + dimsB.w) / 2;
    var diff = Math.abs(dB - dA);
    if (diff < 0.3) return 'Indistinguishable to the naked eye.';
    if (diff < 0.7) return 'Subtle difference — visible side-by-side, easy to miss alone.';
    if (diff < 1.3) return 'Clear difference at hand distance.';
    if (diff < 2.5) return 'Noticeable from across the table.';
    return 'Dramatic difference — instantly visible from across the room.';
  }

  function update() {
    if (!modal.classList.contains('open')) return;
    var pxPerMm = getCalibration();
    var shape = shapeSel.value;
    var grade = gradeSel.value;
    var cA = parseFloat(caratA.value);
    var cB = parseFloat(caratB.value);
    var dA = dimsFor(shape, cA);
    var dB = dimsFor(shape, cB);
    var pA = priceFor(cA, grade);
    var pB = priceFor(cB, grade);

    canvasA.innerHTML =
      '<div class="mdc-stone-illus">' + buildStoneSvg(shape) + '</div>' +
      '<div class="mdc-stone-scale"><span>Actual size</span>' +
      buildScaleMark(shape, dA.l, dA.w, pxPerMm) + '</div>';
    canvasB.innerHTML =
      '<div class="mdc-stone-illus">' + buildStoneSvg(shape) + '</div>' +
      '<div class="mdc-stone-scale"><span>Actual size</span>' +
      buildScaleMark(shape, dB.l, dB.w, pxPerMm) + '</div>';
    mmA.textContent = (dA.l === dA.w ? dA.l.toFixed(1) + ' mm' : dA.l.toFixed(1) + ' × ' + dA.w.toFixed(1) + ' mm');
    mmB.textContent = (dB.l === dB.w ? dB.l.toFixed(1) + ' mm' : dB.l.toFixed(1) + ' × ' + dB.w.toFixed(1) + ' mm');
    priceA.textContent = fmtMoney(pA);
    priceB.textContent = fmtMoney(pB);

    var delta = pB - pA;
    var sign = delta > 0 ? '+' : (delta < 0 ? '−' : '');
    deltaEl.innerHTML = sign + fmtMoney(Math.abs(delta)) + ' &nbsp;·&nbsp; <strong>Option B vs Option A</strong>';
    verdictEl.textContent = visibleDifferenceCopy(dA, dB, shape);

    // Update calibration banner
    if (isCalibrated()) {
      calBanner.classList.add('calibrated');
      calMsg.innerHTML = '<strong>Calibrated</strong> — shown at true millimeter scale.';
      calStart.textContent = 'Recalibrate';
    } else {
      calBanner.classList.remove('calibrated');
      calMsg.innerHTML = '<strong>Estimate mode</strong> — calibrate for true sizing.';
      calStart.textContent = 'Calibrate';
    }
  }

  // ─────────────────────────────────────────────────────────
  // CALIBRATION FLOW
  // ─────────────────────────────────────────────────────────
  function currentRef() {
    var opt = calRefSel.options[calRefSel.selectedIndex];
    return {
      value: opt.value,
      mmW:   parseFloat(opt.dataset.mm),
      mmH:   parseFloat(opt.dataset.h),
      label: opt.dataset.label || opt.textContent,
      isCoin: opt.value.indexOf('card') !== 0  // anything that isn't a card is a coin
    };
  }
  // Guess the visitor's locale → preferred coin denomination
  function localeCoin() {
    try {
      var lang = (navigator.language || navigator.userLanguage || '').toLowerCase();
      var tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || '').toLowerCase();
      // Currency / region hints
      if (lang.indexOf('-ca') >= 0 || tz.indexOf('toronto') >= 0 || tz.indexOf('montreal') >= 0 || tz.indexOf('vancouver') >= 0 || tz.indexOf('halifax') >= 0 || tz.indexOf('edmonton') >= 0) return 'ca-quarter';
      if (lang.indexOf('-us') >= 0 || tz.indexOf('america/') === 0) return 'us-quarter';
      if (lang.indexOf('-gb') >= 0 || lang === 'en-uk' || tz.indexOf('london') >= 0) return 'uk-1pound';
      if (lang.indexOf('-au') >= 0 || tz.indexOf('australia/') === 0) return 'au-1dollar';
      // EU-ish: French, German, Italian, Spanish, Portuguese, Dutch, etc.
      if (/^(fr|de|it|es|pt|nl|el|fi|sv|da|pl|cs|hu|ro)(-|$)/.test(lang)) return 'eu-1euro';
    } catch(e){}
    return 'card-long'; // safe universal fallback
  }
  function pickDefaultRef() {
    // 1. Use saved choice if present
    var saved = localStorage.getItem(CAL_REF_KEY);
    if (saved) {
      for (var i = 0; i < calRefSel.options.length; i++) {
        if (calRefSel.options[i].value === saved) { calRefSel.selectedIndex = i; return; }
      }
    }
    // 2. On wide viewports prefer the universal credit card (most accurate)
    var vw = Math.min(window.innerWidth, document.documentElement.clientWidth);
    if (vw >= 500) { calRefSel.value = 'card-long'; return; }
    // 3. On mobile, use the local coin denomination based on locale
    calRefSel.value = localeCoin();
    // Sanity check: if locale match isn't a real option (shouldn't happen), fall back
    if (calRefSel.selectedIndex < 0) calRefSel.value = 'card-short';
  }
  function openCalibration() {
    pickDefaultRef();
    calUi.classList.add('show');
    refreshCalForRef(true);
  }
  function closeCalibration() {
    calUi.classList.remove('show');
  }
  function refreshCalForRef(initFromCurrent) {
    var ref = currentRef();
    // Clamp slider range so the on-screen object fits the modal width
    var maxPx = Math.min(window.innerWidth * 0.78, 600);
    var minPx = ref.isCoin ? 24 : 60;
    calSlider.min = String(Math.round(minPx));
    calSlider.max = String(Math.round(maxPx));
    if (initFromCurrent) {
      var current = parseFloat(localStorage.getItem(CAL_KEY) || '3.78');
      var initialPx = current * ref.mmW;
      calSlider.value = String(Math.max(minPx, Math.min(maxPx, initialPx)));
    } else {
      // Just clamp current value into new range
      var v = parseFloat(calSlider.value);
      calSlider.value = String(Math.max(minPx, Math.min(maxPx, v)));
    }
    calCard.classList.toggle('is-coin', ref.isCoin);
    calCard.setAttribute('data-label', ref.label);
    updateCalCard();
  }
  function updateCalCard() {
    var ref = currentRef();
    var pxWidth = parseFloat(calSlider.value);
    var pxHeight = pxWidth * (ref.mmH / ref.mmW);
    calCard.style.width = pxWidth + 'px';
    calCard.style.height = pxHeight + 'px';
  }
  function saveCalibration() {
    var ref = currentRef();
    var pxWidth = parseFloat(calSlider.value);
    var pxPerMm = pxWidth / ref.mmW;
    setCalibration(pxPerMm);
    try { localStorage.setItem(CAL_REF_KEY, ref.value); } catch(e){}
    closeCalibration();
    update();
  }

  calStart.addEventListener('click', openCalibration);
  calCancel.addEventListener('click', closeCalibration);
  calSave.addEventListener('click', saveCalibration);
  calSlider.addEventListener('input', updateCalCard);
  calRefSel.addEventListener('change', function(){ refreshCalForRef(true); });

  // ─────────────────────────────────────────────────────────
  // MODAL OPEN/CLOSE
  // ─────────────────────────────────────────────────────────
  function open(opts) {
    opts = opts || {};
    if (opts.shape && SHAPES_1CT[opts.shape]) shapeSel.value = opts.shape;
    if (opts.grade && CLARITY_RATES[opts.grade]) gradeSel.value = opts.grade;
    if (opts.caratA != null) caratA.value = String(opts.caratA);
    if (opts.caratB != null) caratB.value = String(opts.caratB);
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
    update();
  }
  function close() {
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  modal.querySelectorAll('[data-mdc-close]').forEach(function(el){
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) close();
  });

  shapeSel.addEventListener('change', update);
  gradeSel.addEventListener('change', update);
  caratA.addEventListener('change', update);
  caratB.addEventListener('change', update);

  // Expose public API
  window.MontareCompare = { open: open, close: close };
})();
